// Author SWL
// Date 2025-02-12 15:44:47

class EmArchToolChangeDetail {
constructor({
        id = null,
        toolId = '',
        changeFlowId = '',
        quantity = '',
        uniqueCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.toolId = toolId;
    this.changeFlowId = changeFlowId;
    this.quantity = quantity;
    this.uniqueCode = uniqueCode;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchToolChangeDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchToolChangeDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'toolId',
        label: 'label.em.archive.emArchToolChangeDetail.grid.toolId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'changeFlowId',
        label: 'label.em.archive.emArchToolChangeDetail.grid.changeFlowId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'quantity',
        label: 'label.em.archive.emArchToolChangeDetail.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'uniqueCode',
        label: 'label.em.archive.emArchToolChangeDetail.grid.uniqueCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'toolType',
        label: 'label.em.archive.emArchToolChangeDetail.grid.toolType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '工具' },
                            { value: '2', text: '刀具' }
            ]
                }
        },
        {
        key: 'modelNumber',
        label: 'label.em.archive.emArchToolChangeDetail.grid.modelNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'identificationCode',
        label: 'label.em.archive.emArchToolChangeDetail.grid.identificationCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'toolName',
        label: 'label.em.archive.emArchToolChangeDetail.grid.toolName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'detailType',
        label: 'label.em.archive.emArchToolChangeDetail.grid.detailType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'currentCode',
        label: 'label.em.archive.emArchToolChangeDetail.grid.currentCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emArchToolChangeDetail.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bin',
        label: 'label.em.archive.emArchToolChangeDetail.grid.bin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stockQuantity',
        label: 'label.em.archive.emArchToolChangeDetail.grid.stockQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    toolIdFilter : '',
    changeFlowIdFilter : '',
    quantityFilter : '',
    toolTypeFilter : '',
    modelNumberFilter : '',
    identificationCodeFilter : '',
    toolNameFilter : '',
    detailTypeFilter : '',
    uniqueCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'toolIdFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.toolId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchTool'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'changeFlowIdFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.changeFlowId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChange'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'toolTypeFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.toolType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
         ,options: [
                { value: '1', text: '工具' },
                { value: '2', text: '刀具' }
            ]
        }
        },
        {
        key: 'modelNumberFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.modelNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'identificationCodeFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.identificationCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'toolNameFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.toolName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'detailTypeFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.detailType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'uniqueCodeFilter',
        label: 'label.em.archive.emArchToolChangeDetail.filter.uniqueCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'toolId',
        label: 'label.em.archive.emArchToolChangeDetail.entity.toolId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchTool'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'changeFlowId',
        label: 'label.em.archive.emArchToolChangeDetail.entity.changeFlowId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChange'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'quantity',
        label: 'label.em.archive.emArchToolChangeDetail.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'uniqueCode',
        label: 'label.em.archive.emArchToolChangeDetail.entity.uniqueCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmArchToolChangeDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
